import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {withStyles} from 'material-ui/styles';
import styles from '../style/styles';
import TranslationViewContent from './TranslationViewContent';
import {
    fetchBlockSiteTranslation,
} from '../thunks';

class TranslationView extends Component {

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    render() {
        return (
            this.props.loading !== true &&
            <TranslationViewContent
                blockSiteTranslation={this.props.blockSiteTranslation}
                classes={this.props.classes}
            />
        )
    }
}

const mapStateToProps = (state, props) => ({
    blockSiteTranslation: state.blocks.blockSiteTranslation,
    loading: state.layout.ajaxCallsInProgress > 0,
});

export default connect(mapStateToProps, {
    fetchBlockSiteTranslation
})(withStyles(styles)(TranslationView));



// WEBPACK FOOTER //
// ./src/containers/blocks/translations/TranslationView.jsx